export default __webpack_public_path__ + "static/SRI 4815PW - Product Specifications & Technical Data-5e2540c94c17630cdf7bbb86672756dc.pdf";